export const QUERY_KEYS = { KB_ARTICLES: "KB_ARTICLES" };
